import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InsightsHelpModalComponent } from './insights-help-modal.component';



@NgModule({
  declarations: [InsightsHelpModalComponent],
  imports: [
    CommonModule
  ],
  exports: [InsightsHelpModalComponent],
})
export class InsightsHelpModalModule { }
